var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarSmallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3521 3.16165L13.9239 9.45522L20.7042 9.95635L15.5134 14.3471L17.132 20.9503L11.3521 17.3704L5.57217 20.9503L7.19078 14.3471L2 9.95635L8.78026 9.45522L11.3521 3.16165Z",
    fill: "#2B4088"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7814 7.30209L21.7041 8.4013L15.3231 7.87087L12.8592 3C14.1289 5.27591 15.7814 7.30209 15.7814 7.30209Z",
    fill: "#C4251D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0061 14.6763L22 10.5L17.2817 14.5016L18.7725 20.9504C18.5065 18.3579 18.0061 14.6763 18.0061 14.6763Z",
    fill: "#C4251D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSmallIcon);
export default __webpack_public_path__ + "static/media/StarSmallIcon.60c9de6848a9a967f1a77339745ee178.svg";
export { ForwardRef as ReactComponent };